// src/data/press.js

export const PRESS_LINKS = [
  {
    source: "Jutarnji.hr",
    title: "When great pizza meets football: a new beachfront spot in Pag",
    date: "Jun 2025",
    url: "https://www.jutarnji.hr/dobrahrana/price/kad-se-spoje-dobra-pizza-i-nogomet-na-pagu-je-otvorena-nova-pizzerija-ekipa-koja-iza-svega-stoji-ima-ozbiljne-planove-15596649",
    logo: "/img/jutarnji-logo.webp",
    image: "/img/jutarnji-1.jpg",
  },
  {
    source: "Jutarnji.hr",
    title: "A young pizzeria in Pag making some of the best dough on the island",
    date: "Jul 2025",
    url: "https://www.jutarnji.hr/dobrahrana/price/pizzerija-d10-s-pizza-fantasista-otvorena-prije-mjesec-dana-radi-ponajbolje-tijesto-na-otoku-pagu-15601864",
    logo: "/img/jutarnji-logo.webp",
    image: "/img/jutarnji-2.png",
  },
  {
    source: "miss7 / 24sata",
    title: "Pag's standout pizza: ruota di carro + football legends",
    date: "Aug 2025",
    url: "https://miss7.24sata.hr/lifestyle/nadaleko-najbolja-pizza-krije-se-na-pagu-d10-s-spaja-stil-pizze-ruota-di-carro-nogometne-legende-i-sarm-mediterana-57641",
    logo: "/img/24_sata.svg.png",
    image: "/img/24sata-1.jpeg",
  },
  {
    source: "Index.hr",
    title: "Pizza show in Pag: the event hosted at D10's Pizza Fantasista",
    date: "Sep 2025",
    url: "https://www.index.hr/food/clanak/pizza-show-na-pagu-pobijedili-majstori-s-vira-i-murtera-briljirala-i-zagrepcanka/2711614.aspx",
    logo: "/img/index-logo.png",
    image: "/img/index-slika.jpg",
  },
  {
  source: "Vogue Adria",
  title: "One of the world’s best pizzas: D10’s Pizza Fantasista in Pag",
  date: "Sep 2025",
  url: "https://vogueadria.com/hr/pizzeria-shango-najboja-pizza-zagreb/",
  logo: "/img/vogue.svg",
  image: "/img/vogue-d10.jpg",
},

{
  source: "Svet24 / Dober Tek",
  title: "Picerija D10’s – a perfect ten on Pag",
  date: "Aug 2025",
  url: "https://svet24.si/kulinarika/dober-tek/novice/gospodarstvo/turizem/picerija-d10s-cista-desetica-na-pagu-1839132",
  logo: "/img/svet24-logo.png",
  image: "/img/svet24-d10.jpeg",
}


];
